import { AddressSuggestion } from "../types/address-suggestion";
import {
  TypeAddress,
  TypeAddressLabel,
} from "../types/records/type-address-record";

/**
 * Lieux remarquables proposes en raccourci dans la palette de recherche
 * d adresse, avant et pendant la saisie. Completes par les POI renvoyes par
 * l API : cette liste ne fait que garantir les destinations les plus
 * frequentes (gares, aeroports).
 */
export const poiAddresses: AddressSuggestion[] = [
  {
    id: "poi-2",
    label: "Gare de Bruxelles-Midi",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "train",
    adresse: {
      rue: "Avenue Fonsny",
      numero: "47B",
      boite: "",
      codePostal: "1060",
      ville: "Saint-Gilles",
      pays: "Belgique",
    },
  },
  {
    id: "poi-3",
    label: "Charleroi Airport (CRL)",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "flight",
    adresse: {
      rue: "Rue des Frères Wright",
      numero: "8",
      boite: "",
      codePostal: "6041",
      ville: "Gosselies",
      pays: "Belgique",
    },
  },
  {
    id: "poi-4",
    label: "Gare de Bruxelles-Central",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "train",
    adresse: {
      rue: "Carrefour de l'Europe",
      numero: "2",
      boite: "",
      codePostal: "1000",
      ville: "Bruxelles",
      pays: "Belgique",
    },
  },
  {
    id: "poi-5",
    label: "Grand Place de Bruxelles",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "location_city",
    adresse: {
      rue: "Grand Place",
      numero: "1",
      boite: "",
      codePostal: "1000",
      ville: "Bruxelles",
      pays: "Belgique",
    },
  },
  {
    id: "poi-6",
    label: "Atomium",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "museum",
    adresse: {
      rue: "Place de l'Atomium",
      numero: "1",
      boite: "",
      codePostal: "1020",
      ville: "Bruxelles",
      pays: "Belgique",
    },
  },
  {
    id: "poi-7",
    label: "Gare de Liège-Guillemins",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "train",
    adresse: {
      rue: "Place des Guillemins",
      numero: "2",
      boite: "",
      codePostal: "4000",
      ville: "Liège",
      pays: "Belgique",
    },
  },
  {
    id: "poi-8",
    label: "Pairi Daiza",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "pets",
    adresse: {
      rue: "Domaine de Cambron",
      numero: "1",
      boite: "",
      codePostal: "7940",
      ville: "Brugelette",
      pays: "Belgique",
    },
  },
  {
    id: "poi-9",
    label: "Hôpital Erasme",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "local_hospital",
    adresse: {
      rue: "Route de Lennik",
      numero: "808",
      boite: "",
      codePostal: "1070",
      ville: "Anderlecht",
      pays: "Belgique",
    },
  },
  {
    id: "poi-10",
    label: "Anvers-Central (Antwerpen-Centraal)",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "train",
    adresse: {
      rue: "Koningin Astridplein",
      numero: "27",
      boite: "",
      codePostal: "2018",
      ville: "Anvers",
      pays: "Belgique",
    },
  },
  {
    id: "poi-11",
    label: "Stade Roi Baudouin",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "stadium",
    adresse: {
      rue: "Avenue de Marathon",
      numero: "135",
      boite: "",
      codePostal: "1020",
      ville: "Bruxelles",
      pays: "Belgique",
    },
  },
  {
    id: "poi-12",
    label: "Médiacité Liège",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "shopping_bag",
    adresse: {
      rue: "Boulevard Raymond Poincaré",
      numero: "7",
      boite: "",
      codePostal: "4020",
      ville: "Liège",
      pays: "Belgique",
    },
  },
  {
    id: "poi-13",
    label: "Circuit de Spa-Francorchamps",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "directions_car",
    adresse: {
      rue: "Route du Circuit",
      numero: "55",
      boite: "",
      codePostal: "4970",
      ville: "Stavelot",
      pays: "Belgique",
    },
  },
  {
    id: "poi-14",
    label: "Namur Expo",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "event",
    adresse: {
      rue: "Avenue Sergent Vrithoff",
      numero: "2",
      boite: "",
      codePostal: "5000",
      ville: "Namur",
      pays: "Belgique",
    },
  },
  {
    id: "poi-15",
    label: "Parc du Cinquantenaire",
    type: TypeAddressLabel[TypeAddress.POI] ?? "poi",
    icon: "park",
    adresse: {
      rue: "Avenue de la Renaissance",
      numero: "1",
      boite: "",
      codePostal: "1000",
      ville: "Bruxelles",
      pays: "Belgique",
    },
  },
];
